'use client';

import React, { useState, useEffect, useRef } from 'react';

interface ActivityEntry {
  name: string;
  locality: string;
  rate: string;
}

const DUMMY_ENTRIES: ActivityEntry[] = [
  { name: 'Rohan', locality: 'Dwarka Sec 21', rate: '50K' },
  { name: 'Shivani', locality: 'Goyla Khurd', rate: '25K' },
  { name: 'Amit', locality: 'Uttam Nagar', rate: '38K' },
  { name: 'Priya', locality: 'Janakpuri', rate: '72K' },
  { name: 'Suresh', locality: 'Dwarka Sec 10', rate: '55K' },
  { name: 'Neha', locality: 'Palam Village', rate: '30K' },
  { name: 'Vikram', locality: 'Najafgarh', rate: '18K' },
  { name: 'Kavita', locality: 'Dwarka Sec 6', rate: '62K' },
  { name: 'Rajesh', locality: 'Bindapur', rate: '28K' },
  { name: 'Sunita', locality: 'Nawada', rate: '35K' },
  { name: 'Deepak', locality: 'Dwarka Sec 12', rate: '58K' },
  { name: 'Anita', locality: 'Kakrola', rate: '22K' },
  { name: 'Mohit', locality: 'Dwarka Sec 4', rate: '65K' },
  { name: 'Pooja', locality: 'Matiala', rate: '20K' },
  { name: 'Sanjay', locality: 'Dwarka Sec 14', rate: '60K' },
  { name: 'Rekha', locality: 'Dashrath Puri', rate: '32K' },
  { name: 'Arun', locality: 'Dwarka Sec 7', rate: '68K' },
  { name: 'Meena', locality: 'Sagarpur', rate: '42K' },
  { name: 'Rahul', locality: 'Dwarka Sec 23', rate: '48K' },
  { name: 'Geeta', locality: 'Mohan Garden', rate: '36K' },
  { name: 'Pankaj', locality: 'Dwarka Sec 3', rate: '70K' },
  { name: 'Suman', locality: 'Vikas Puri', rate: '55K' },
  { name: 'Tarun', locality: 'Dwarka Sec 17', rate: '52K' },
  { name: 'Nisha', locality: 'Tilak Nagar', rate: '78K' },
  { name: 'Gaurav', locality: 'Dwarka Sec 9', rate: '63K' },
  { name: 'Ritu', locality: 'Subhash Nagar', rate: '80K' },
  { name: 'Manish', locality: 'Dwarka Sec 19', rate: '47K' },
  { name: 'Seema', locality: 'Hari Nagar', rate: '75K' },
  { name: 'Vivek', locality: 'Dwarka Sec 11', rate: '57K' },
  { name: 'Asha', locality: 'Khyala', rate: '40K' },
  { name: 'Nitin', locality: 'Dwarka Sec 5', rate: '66K' },
  { name: 'Lata', locality: 'Rajouri Garden', rate: '90K' },
  { name: 'Sachin', locality: 'Dwarka Sec 13', rate: '59K' },
  { name: 'Usha', locality: 'Tagore Garden', rate: '85K' },
  { name: 'Dinesh', locality: 'Dwarka Sec 8', rate: '64K' },
  { name: 'Manju', locality: 'Paschim Vihar', rate: '88K' },
  { name: 'Harish', locality: 'Dwarka Sec 16', rate: '53K' },
  { name: 'Babita', locality: 'Punjabi Bagh', rate: '95K' },
  { name: 'Sunil', locality: 'Dwarka Sec 18', rate: '49K' },
  { name: 'Kamla', locality: 'Shalimar Bagh', rate: '92K' },
  { name: 'Ajay', locality: 'Dwarka Sec 22', rate: '46K' },
  { name: 'Saroj', locality: 'Rohini Sec 3', rate: '45K' },
  { name: 'Manoj', locality: 'Dwarka Sec 2', rate: '71K' },
  { name: 'Pushpa', locality: 'Rohini Sec 7', rate: '43K' },
  { name: 'Ravi', locality: 'Dwarka Sec 15', rate: '56K' },
  { name: 'Savita', locality: 'Rohini Sec 11', rate: '41K' },
  { name: 'Kiran', locality: 'Dwarka Sec 20', rate: '51K' },
  { name: 'Vinod', locality: 'Pitampura', rate: '82K' },
  { name: 'Sudha', locality: 'Dwarka Sec 1', rate: '73K' },
  { name: 'Ashok', locality: 'Netaji Subhash Place', rate: '87K' },
  { name: 'Radha', locality: 'Dwarka Sec 24', rate: '44K' },
  { name: 'Bharat', locality: 'Shakurpur', rate: '39K' },
  { name: 'Chanda', locality: 'Dwarka Sec 25', rate: '42K' },
  { name: 'Devesh', locality: 'Wazirpur', rate: '37K' },
  { name: 'Falguni', locality: 'Dwarka Sec 26', rate: '40K' },
  { name: 'Girish', locality: 'Ashok Vihar', rate: '76K' },
  { name: 'Hema', locality: 'Dwarka Sec 27', rate: '38K' },
  { name: 'Ishaan', locality: 'Model Town', rate: '83K' },
  { name: 'Jyoti', locality: 'Dwarka Sec 28', rate: '36K' },
  { name: 'Kapil', locality: 'Mukherjee Nagar', rate: '69K' },
  { name: 'Lalita', locality: 'Dwarka Sec 29', rate: '34K' },
  { name: 'Mukesh', locality: 'Adarsh Nagar', rate: '67K' },
  { name: 'Nalini', locality: 'Dwarka Sec 30', rate: '33K' },
  { name: 'Om Prakash', locality: 'Azadpur', rate: '31K' },
  { name: 'Parvati', locality: 'Dwarka Mor', rate: '29K' },
  { name: 'Qadir', locality: 'Nangloi', rate: '24K' },
  { name: 'Renu', locality: 'Dwarka Expressway', rate: '54K' },
  { name: 'Shyam', locality: 'Sector 45 Gurugram', rate: '110K' },
  { name: 'Tara', locality: 'Dwarka Sec 31', rate: '27K' },
  { name: 'Umesh', locality: 'Sector 56 Gurugram', rate: '105K' },
  { name: 'Vandana', locality: 'Dwarka Sec 32', rate: '26K' },
  { name: 'Wasim', locality: 'Sector 23 Gurugram', rate: '98K' },
  { name: 'Xenia', locality: 'Dwarka Sec 33', rate: '25K' },
  { name: 'Yogesh', locality: 'Sector 14 Gurugram', rate: '115K' },
  { name: 'Zara', locality: 'Dwarka Sec 34', rate: '23K' },
  { name: 'Alok', locality: 'Sector 9 Gurugram', rate: '120K' },
  { name: 'Bhavna', locality: 'Dwarka Sec 35', rate: '22K' },
  { name: 'Chirag', locality: 'Sector 37 Gurugram', rate: '108K' },
  { name: 'Divya', locality: 'Dwarka Sec 36', rate: '21K' },
  { name: 'Esha', locality: 'Sector 49 Gurugram', rate: '102K' },
  { name: 'Farhan', locality: 'Dwarka Sec 37', rate: '20K' },
  { name: 'Garima', locality: 'Sector 57 Gurugram', rate: '99K' },
  { name: 'Hemant', locality: 'Dwarka Sec 38', rate: '19K' },
  { name: 'Isha', locality: 'Sector 82 Gurugram', rate: '96K' },
  { name: 'Jagdish', locality: 'Dwarka Sec 39', rate: '18K' },
  { name: 'Komal', locality: 'Sector 83 Gurugram', rate: '94K' },
  { name: 'Lokesh', locality: 'Dwarka Sec 40', rate: '17K' },
  { name: 'Madhuri', locality: 'Sector 84 Gurugram', rate: '91K' },
  { name: 'Naresh', locality: 'Dwarka Sec 41', rate: '16K' },
  { name: 'Omkar', locality: 'Sector 85 Gurugram', rate: '89K' },
  { name: 'Padma', locality: 'Dwarka Sec 42', rate: '15K' },
  { name: 'Qasim', locality: 'Sector 86 Gurugram', rate: '86K' },
  { name: 'Rohini', locality: 'Dwarka Sec 43', rate: '14K' },
  { name: 'Shobha', locality: 'Sector 87 Gurugram', rate: '84K' },
  { name: 'Trilok', locality: 'Dwarka Sec 44', rate: '13K' },
  { name: 'Urmila', locality: 'Sector 88 Gurugram', rate: '81K' },
  { name: 'Vijay', locality: 'Dwarka Sec 45', rate: '12K' },
  { name: 'Waqar', locality: 'Sector 89 Gurugram', rate: '79K' },
  { name: 'Yamini', locality: 'Dwarka Sec 46', rate: '11K' },
  { name: 'Zubin', locality: 'Sector 90 Gurugram', rate: '77K' },
];

interface FeedItem extends ActivityEntry {
  id: number;
  timestamp: number;
}

function shuffleArray<T>(arr: T[]): T[] {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

function getRelativeTime(timestamp: number, now: number): string {
  const diffSec = Math.floor((now - timestamp) / 1000);
  if (diffSec < 60) return `${diffSec}s ago`;
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin} min${diffMin === 1 ? '' : 's'} ago`;
  const diffHr = Math.floor(diffMin / 60);
  return `${diffHr} hr${diffHr === 1 ? '' : 's'} ago`;
}

export default function ActivityThread() {
  const [feed, setFeed] = useState<FeedItem[]>([]);
  const [now, setNow] = useState<number>(0);
  const queueRef = useRef<ActivityEntry[]>([]);
  const counterRef = useRef(0);

  // Tick every second to update relative timestamps
  useEffect(() => {
    setNow(Date.now());
    const tick = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(tick);
  }, []);

  useEffect(() => {
    // Build initial shuffled queue
    queueRef.current = shuffleArray(DUMMY_ENTRIES);

    const getNext = (): ActivityEntry => {
      if (queueRef.current.length === 0) {
        queueRef.current = shuffleArray(DUMMY_ENTRIES);
      }
      return queueRef.current.shift()!;
    };

    // Seed with 3 initial items, oldest at top, newest at bottom
    const initial: FeedItem[] = [];
    for (let i = 0; i < 1; i++) {
      const entry = getNext();
      // i=0 is oldest (top), i=2 is newest (bottom)
      initial.push({ ...entry, id: counterRef.current++, timestamp: Date.now() - (2 - i) * 20000 });
    }
    setFeed(initial);

    // Schedule a new entry every 60 seconds, but trigger it at a random offset within 1–60s
    let cycleStart = Date.now();

    const scheduleNext = () => {
      // Random offset between 1000ms and 60000ms
      const offset = 1000 + Math.floor(Math.random() * 59000);
      return setTimeout(() => {
        const entry = getNext();
        setFeed(prev => {
          const newItem: FeedItem = { ...entry, id: counterRef.current++, timestamp: Date.now() };
          // Remove top (oldest) entry, shift remaining up, append new at bottom
          const updated = prev.slice(1);
          return [newItem];
        });
        // Wait for the remainder of the 60s cycle before scheduling the next one
        const elapsed = Date.now() - cycleStart;
        const remainder = Math.max(0, 60000 - elapsed);
        cycleStart = Date.now() + remainder;
        setTimeout(() => {
          cycleStart = Date.now();
          timerRef.current = scheduleNext();
        }, remainder);
      }, offset);
    };

    const timerRef: { current: ReturnType<typeof setTimeout> | undefined } = { current: undefined };
    cycleStart = Date.now();
    timerRef.current = scheduleNext();

    return () => clearTimeout(timerRef.current);
  }, []);

  return (
    <div
      className="activity-thread-panel"
      style={{
        position: 'absolute',
        top: 16,
        right: 16,
        width: 260,
        maxHeight: 'calc(100vh - 32px)',
        overflowY: 'hidden',
        zIndex: 400,
        flexDirection: 'column',
        gap: 8,
        pointerEvents: 'none',
      }}
    >
      {feed.map((item, idx) => (
        <div
          key={item.id}
          className="activity-thread-card"
          style={{
            background: 'rgba(255,255,255,0.92)',
            backdropFilter: 'blur(8px)',
            borderRadius: 12,
            padding: '8px 12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
            opacity: idx === feed.length - 1 ? 1 : Math.max(0.35, 1 - (feed.length - 1 - idx) * 0.08),
            transform: `scale(${idx === feed.length - 1 ? 1 : Math.max(0.94, 1 - (feed.length - 1 - idx) * 0.01)})`,
            transformOrigin: 'top right',
            transition: 'opacity 0.4s ease, transform 0.4s ease',
            borderLeft: '3px solid #0056D2',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
            <div
              className="activity-thread-avatar"
              style={{
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #0056D2, #3b82f6)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontWeight: 700,
                color: '#fff',
                flexShrink: 0,
              }}
            >
              {item.name.charAt(0)}
            </div>
            <span className="activity-thread-name" style={{ fontWeight: 600, color: '#111827', lineHeight: 1.2 }}>
              {item.name}
            </span>
            <span className="activity-thread-time" style={{ color: '#6b7280', marginLeft: 'auto', whiteSpace: 'nowrap' }}>
              {now > 0 ? getRelativeTime(item.timestamp, now) : ''}
            </span>
          </div>
          <p className="activity-thread-body" style={{ color: '#374151', margin: 0, lineHeight: 1.4 }}>
            just added a new rate!{' '}
            <span style={{ fontWeight: 600, color: '#0056D2' }}>
              {item.locality} — {item.rate} per gaz
            </span>
          </p>
        </div>
      ))}
    </div>
  );
}
